import { Anchor, Group, List, Text } from "@mantine/core";
import { IconQuote } from "@tabler/icons-react";

export default function CitationsList({ citations }) {
  if (!citations?.length) return null;

  return (
    <div style={{ marginTop: 6 }}>
      <Group gap={4} mb={4}>
        <IconQuote size={12} color="var(--mantine-color-teal-6)" />
        <Text size="xs" fw={600} c="teal">
          {citations.length} {citations.length === 1 ? "source" : "sources"}
        </Text>
      </Group>
      <List size="xs" type="ordered" spacing={0}>
        {citations.map((c, i) => (
          <List.Item key={i}>
            <Anchor
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              size="xs"
            >
              {c.title || c.url}
            </Anchor>
          </List.Item>
        ))}
      </List>
    </div>
  );
}
